// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"93504939","198":"4507c2fc","404":"b9e661d2","560":"58102ffe","633":"f68eeb3c","736":"ff3d10e3"}[chunkId] + ".chunk.js";
};